if (!customElements.get('ph-mega')) {
  customElements.define('ph-mega', class extends HTMLElement {
    connectedCallback() {
      const tabs = this.querySelectorAll('[data-ph-tab]');
      const panes = this.querySelectorAll('[data-ph-pane]');
      const set = (i) => {
        tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.phTab === i));
        panes.forEach((p) => (p.hidden = p.dataset.phPane !== i));
      };
      tabs.forEach((t) => {
        t.addEventListener('pointerenter', () => set(t.dataset.phTab));
        t.addEventListener('focus', () => set(t.dataset.phTab));
      });
      // Load the product images only when this menu is first used, not on every page view.
      if (!this.phLoadBound) {
        this.phLoadBound = true;
        const load = () => {
          this.querySelectorAll('img[data-ph-src]').forEach((img) => {
            img.src = img.dataset.phSrc;
            img.removeAttribute('data-ph-src');
          });
        };
        const host = this.closest('.menu-list__list-item') || this;
        ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => host.addEventListener(ev, load, { once: true, passive: true }));
      }
    }
  });
}
if (!customElements.get('ph-drawer')) {
  customElements.define('ph-drawer', class extends HTMLElement {
    connectedCallback() {
      const local = this.querySelector('.ph-drawer__panel');
      if (local) {
        document.querySelectorAll('body > .ph-drawer__panel').forEach((p) => p.remove());
        document.body.appendChild(local);
        this.panel = local;
      } else {
        this.panel = document.querySelector('body > .ph-drawer__panel');
      }
      this.toggleBtn = this.querySelector('.ph-drawer__toggle');
      if (this.bound) return;
      this.bound = true;
      this.toggleBtn?.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.setOpen(true); });
      this.panel?.addEventListener('click', (e) => {
        const t = e.target.closest('[data-ph-action]');
        if (!t) return;
        const a = t.dataset.phAction;
        if (a === 'close') this.setOpen(false);
        else if (a === 'open') this.show(t.dataset.phIndex);
        else if (a === 'back') this.show('root');
        else if (a === 'chip') this.chip(t);
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.setOpen(false); });
      window.matchMedia('(min-width: 750px)').addEventListener('change', (m) => { if (m.matches) this.setOpen(false); });
    }
    setOpen(open) {
      if (!this.panel) return;
      this.panel.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('ph-lock', open);
      this.toggleBtn?.setAttribute('aria-expanded', String(open));
      this.show('root');
    }
    show(level) {
      this.panel.querySelectorAll('[data-ph-level]').forEach((l) => (l.hidden = l.dataset.phLevel !== String(level)));
      this.panel.querySelector('[data-ph-level]:not([hidden])')?.scrollTo(0, 0);
    }
    chip(t) {
      const lvl = t.closest('[data-ph-level]');
      lvl.querySelectorAll('[data-ph-action="chip"]').forEach((c) => {
        c.classList.toggle('is-active', c === t);
        c.hidden = false;
      });
      // Chips also carry data-ph-pane, so exclude them: only toggle the content panes.
      lvl.querySelectorAll('[data-ph-pane]:not([data-ph-action])').forEach((p) => (p.hidden = p.dataset.phPane !== t.dataset.phPane));
    }
  });
}
